import { QuestType } from "Infrastructure/Api/Api";
import {
  getTranslation,
  Resources,
} from "Infrastructure/Translations/Resources";
import { z } from "zod";

export const questSchema = z
  .object({
    title: z
      .string()
      .min(1, getTranslation(Resources.Validation.Required))
      .max(50, getTranslation(Resources.Validation.MaxLength))
      .refine((val) => val.trim().length > 0, {
        message: getTranslation(Resources.Validation.Required),
      })
      .transform((val) => val.trim().replace(/\s+/g, " ")),
    reward: z.coerce
      .number({
        required_error: getTranslation(Resources.Validation.Required),
        invalid_type_error: getTranslation(Resources.Validation.Required),
      })
      .positive(getTranslation(Resources.Validation.Positive)),
    start: z.date().optional(),
    expiration: z.date().optional(),
    description: z
      .string()
      .max(300, getTranslation(Resources.Validation.MaxLength))
      .optional(),
    type: z.nativeEnum(QuestType).default(QuestType.BugHunter),
    maxParticipants: z.coerce.number().nullable().optional(),
  })
  .refine(
    (data) => !data.start || !data.expiration || data.expiration >= data.start,
    {
      message: getTranslation(Resources.Validation.DateRange),
      path: ["expiration"],
    },
  );

export type QuestFormData = z.infer<typeof questSchema>;
export type QuestFormInput = z.input<typeof questSchema>;
